export const spacesOutsideParentheses = / (?=([^()]*\([^()]*\))*[^()]*$)/g
export const unsafeClassNameCharacters = /[^_a-zA-Z0-9-]/g
